import { createElement, ForwardedRef, ReactNode } from 'react';
import * as motion from 'motion/react-client';
import {
  fadeInUp,
  //  splitWords as splitWordsAnimation
} from '@/animations';
// import { splitWords, stripHtml, isFunction } from '@/utils';
// import classNames from 'classnames';
import { AnimationProps } from './Box';

export interface ITextProps extends React.HTMLAttributes<HTMLElement>, AnimationProps {
  tag?: string;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
  className?: string;
  children?: ReactNode;
  ref?: ForwardedRef<HTMLElement>;
}

const Text = ({
  tag = 'div',
  animation = fadeInUp,
  animate = true,
  dangerouslySetInnerHTML,
  className,
  children,
  ...props
}: ITextProps) => {
  const _animate = animate && animation;
  const _motion = _animate ? animation : null;
  /*
  if (
    _animate &&
    isFunction(animation) &&
    isFunction(splitWordsAnimation) &&
    splitWordsAnimation().name === animation().name
  ) {
    const words = splitWords(stripHtml(children || dangerouslySetInnerHTML?.__html) || '');
    const renderText = words.map((val: string, i: number) => {
      return createElement(getMotionTag('span'), { ...(isFunction(animation) ? animation().motion : {}), key: i }, val);
    });
    return createElement(
      tag,
      {
        ...props,
        className: classNames(className, 'flex flex-wrap gap-[1rem]'),
      },
      renderText,
    );
  }
*/
  return createElement(
    _animate ? getMotionTag(tag) : tag,
    {
      ...props,
      ...(_animate ? _motion : {}),
      className,
      dangerouslySetInnerHTML,
    },
    children,
  );
};
const getMotionTag = (tag: string) => {
  const tags: { [key: string]: any } = {
    p: motion.p,
    h1: motion.h1,
    h2: motion.h2,
    h3: motion.h3,
    h4: motion.h4,
    h5: motion.h5,
    h6: motion.h6,
    span: motion.span,
    div: motion.div,
  };

  return tags[tag] || motion.div;
};

Text.displayName = 'Text';

export default Text;
